import { Props } from "./types";
import SingleArticle from "../singleArticle";

const NextBlogPost = ({ nextArticle, baseUrl }: Props): JSX.Element => {
  return (
    <>
      {nextArticle?.data !== null && (
        <div className={`flex flex-col w-full md:w-1/2`}>
          <SingleArticle
            article={{ id: nextArticle?.data?.id, attributes: nextArticle?.data?.attributes }}
            baseUrl={baseUrl}
          />
        </div>
      )}
    </>
  );
};

export default NextBlogPost;
